import {
    SharingAudience, ISharingLinkAbilities, ISharingLinkAbilitiesMatrix
} from '../interfaces/SharingInterfaces';

/**
 * Translate the key from the server to a SharingAudience.
 *
 * @param key The key describes the link type.
 */
export function getSharingAbilitiesAudience(key: string): SharingAudience {
    if (key === 'anonymousLinkAbilities') {
        return SharingAudience.anyone;
    } else if (key === 'organizationLinkAbilities') {
        return SharingAudience.organization;
    } else if (key === 'peopleSharingLinkAbilities') {
        return SharingAudience.specificPeopleFlex;
    }

    return undefined;
}

/**
 * Gets the sharing abilitites for the given audience.
 *
 * @param audience The sharing audience to get link information about.
 * @param sharingAbilities Complete matrix of sharing abilities.
 */
export function getSharingAbilitiesByAudience(audience: SharingAudience, sharingAbilities: ISharingLinkAbilitiesMatrix): ISharingLinkAbilities {
    if (audience === SharingAudience.anyone) {
        return sharingAbilities.anonymousLinkAbilities;
    } else if (audience === SharingAudience.organization) {
        return sharingAbilities.organizationLinkAbilities;
    } else if (audience === SharingAudience.specificPeopleFlex) {
        return sharingAbilities.peopleSharingLinkAbilities;
    } else {
        return sharingAbilities.directSharingAbilities;
    }
}

/**
 * Determines if editing is allowed for a share to the given audience.
 *
 * @param audience The sharing audience to get link information about.
 * @param sharingAbilities Complete matrix of sharing abilities.
 */
export function isEditingAllowed(audience: SharingAudience, sharingAbilities: ISharingLinkAbilitiesMatrix): boolean {
    const abilities = getSharingAbilitiesByAudience(audience, sharingAbilities);

    if (abilities.canManageEditLink) {
        return abilities.canManageEditLink.enabled;
    } else {
        return true;
    }
}

/**
 * Determines if restricted view is supported for sharing.
 * @param audience The current sharing audience.
 * @param sharingAbilities Complete matrix of sharing abilities.
 */
export function supportsRestrictedView(audience: SharingAudience, sharingAbilities: ISharingLinkAbilitiesMatrix): boolean {
    const abilities = getSharingAbilitiesByAudience(audience, sharingAbilities);

    if (abilities.supportsRestrictedView) {
        return abilities.supportsRestrictedView.enabled;
    } else {
        return false;
    }
}